import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Lock, Clock, User, CheckCircle2, ChevronLeft, Wrench } from "lucide-react";
import { IN_DEV_COURSES } from "../data/inDevCourses";

export const CoursePreviewPage = () => {
  const { slug } = useParams();
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  const course = IN_DEV_COURSES.find((c) => c.slug === slug);

  if (!course) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <div className="text-center">
          <p className="text-neutral-text/60 mb-4">Курс не найден</p>
          <Link to="/courses" className="text-primary hover:underline text-sm">
            ← Назад к курсам
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-full bg-neutral-light overflow-y-auto">
      {/* Hero */}
      <div className={`relative ${course.backgroundPattern}`}>
        <div className="absolute inset-0 bg-black/40" />
        <div className="relative z-10 max-w-3xl mx-auto px-6 py-12">
          <Link
            to="/courses"
            className="inline-flex items-center gap-1.5 text-white/70 hover:text-white text-sm mb-6 transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
            Все курсы
          </Link>

          <div className="flex items-center gap-2 mb-3">
            <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold bg-white/20 text-white backdrop-blur-sm border border-white/30">
              <User className="h-3 w-3" />
              {course.targetLevel}
            </span>
            <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold bg-orange-500/90 text-white">
              <Wrench className="h-3 w-3" />
              В разработке
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3 leading-snug">
            {course.title}
          </h1>
          <p className="text-white/75 text-base leading-relaxed max-w-xl">
            {course.description}
          </p>

          <div className="flex items-center gap-4 mt-6">
            <span className="inline-flex items-center gap-1.5 text-white/80 text-sm">
              <Clock className="w-4 h-4" />≈ {course.durationHours} часов
            </span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-10 space-y-8">

        {/* What you'll learn */}
        <section className="bg-white rounded-2xl p-6 border border-neutral-border shadow-sm">
          <h2 className="text-xs font-semibold text-neutral-text/40 uppercase tracking-wider mb-4">
            Что изучите
          </h2>
          <ul className="grid sm:grid-cols-2 gap-3">
            {course.highlights.map((h) => (
              <li key={h} className="flex items-start gap-2.5">
                <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-sm text-neutral-text/80 leading-snug">{h}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* For whom */}
        <section className="bg-white rounded-2xl p-6 border border-neutral-border shadow-sm">
          <h2 className="text-xs font-semibold text-neutral-text/40 uppercase tracking-wider mb-3">
            Для кого этот курс
          </h2>
          <p className="text-sm text-neutral-text/75 leading-relaxed">{course.forWhom}</p>
        </section>

        {/* Expertise note */}
        <p className="text-xs text-neutral-text/40 italic px-1">{course.expertiseNote}</p>

        {/* CTA — locked */}
        <div className="bg-white rounded-2xl p-6 border border-neutral-border shadow-sm flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-semibold text-neutral-text mb-0.5">Стоимость</p>
            <div className="h-8 w-36 bg-neutral-200 rounded-lg mt-1 mb-1" />
            <p className="text-xs text-neutral-text/45">скоро объявим цену</p>
          </div>
          <button
            disabled
            className="flex items-center justify-center gap-2 px-8 py-3 rounded-xl bg-neutral-100 text-neutral-text/40 text-sm font-semibold cursor-not-allowed border border-neutral-border w-full sm:w-auto"
          >
            <Lock className="w-4 h-4" />
            Курс в разработке
          </button>
        </div>

      </div>
    </div>
  );
};
